import { createContext } from "react"
import { ModalContext as ModalContextType } from "./types"
import { initial_modal } from "./reducer"

const ModalContext = createContext<ModalContextType>({ modal: initial_modal, dispatch: () => null })
export default ModalContext
